import { Box, Tooltip, Typography } from "@mui/material";
import { useMaterialColor } from "hooks/useMaterials";

interface RecipeHeaderProps {
  materials: string[];
  shortNames: Record<string, string>;
  ignoredMaterials: Set<string>;
  size?: string;
  showColors?: boolean;
}

export const RecipeHeader = ({
  materials,
  shortNames,
  size,
  ignoredMaterials,
  showColors = true,
}: RecipeHeaderProps) => {
  const { getColor } = useMaterialColor();
  return (
    <Box
      sx={{
        display: "flex",
        gap: 1.0,
        width: "100%",
      }}
    >
      {materials.map((material) => (
        <Tooltip key={material} title={material}>
          <Typography
            key={material}
            sx={{
              flex: 1,
              fontSize: size,
              textAlign: "center",
              fontWeight: "fontWeightSemiBold",
              color: showColors
                ? getColor(material, [...ignoredMaterials].includes(material))
                : undefined,
            }}
          >
            {shortNames[material] ?? material.slice(0, 4).toUpperCase()}
          </Typography>
        </Tooltip>
      ))}
    </Box>
  );
};
